import { Box } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const OfficeBox = ({ children, innerRef, ...props }) => {
  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box
      {...props}
      ref={innerRef}
      border="1px solid rgba(145, 158, 171, 0.1);"
      boxShadow="0px 1px 3px rgba(145, 158, 171, 0.1)"
      backgroundColor="white"
      borderRadius={viewportIsSmall ? "12px" : ""}
      color="rgba(21, 56, 98, 1)"
    >
      {children}
    </Box>
  );
};

export { OfficeBox };
